module.exports = "<button class=\"tab e2e-id--sms-notifications-tab--header\"\r\n        ng-class=\"{active: $ctrl.isActive}\"\r\n        ng-click=\"$ctrl.onSelect({tab: 'email'})\"\r\n        translate>SMS Notifications\r\n</button>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/sms/components/sms-notification-templates/components/sms-notification-tab/components/tab-header/tab-header.html
// module id = 1296
// module chunks = 0